import React from "react";
import { CssBaseline, ThemeProvider } from "@mui/material";
import { ColorModeContext, useMode } from "./theme";
import CustomToast from "./components/common/CustomToast";
import { BrowserRouter as Router } from "react-router-dom";
import AppRoutes from "./config/AppRoutes";
import { useAppDispatch, useAppSelector } from "./redux/store";
import { getSchool } from "./redux/actions/schoolActions";
import { getBranchSettings } from "./redux/actions/settingsActions";
import { checkSystemStatus } from "./redux/actions/appStatusActions";
import GlobalLicenseModal from "./components/license/GlobalLicenseModal";

const App = () => {
  const [theme, colorMode] = useMode();
  const dispatch = useAppDispatch();

  const { userInfo } = useAppSelector((state) => state.auth);

  React.useEffect(() => {
    dispatch(checkSystemStatus());
    dispatch(getSchool());
  }, [dispatch]);

  React.useEffect(() => {
    if (userInfo) {
      dispatch(getBranchSettings());
    }
  }, [dispatch, userInfo]);

  return (
    <ColorModeContext.Provider value={colorMode}>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <CustomToast />
        <GlobalLicenseModal />
        <Router>
          <AppRoutes />
        </Router>
      </ThemeProvider>
    </ColorModeContext.Provider>
  );
};

export default App;
